import React, { useState, useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Drawer,
  Row,
  Col,
  Divider,
  Popconfirm,
  message,
  Space,
  Descriptions,
} from "antd";
import CreateNewSchedule from "../Schedule/CreateNewSchedule";
import ScheduleList from "../Schedule/ScheduleList";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { deleteService, getSpecificService } from "../../../../actions/Appointment/serviceAction";

const ServiceDetails = ({ details, setUpdatelist, deleteService, getSpecificService }) => {
  const [visible, setVisible] = useState(false);
  const [serviceData, setServiceData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setVisible(false);
    setUpdatelist(false);
  };

  const fetchServiceData = async () => {
    if (!details || !details.id) return;
    setLoading(true);
    try {
      const data = await getSpecificService(details.id);
      console.log("Service Data:", data);
      setServiceData(data);
    } catch (error) {
      message.error("Failed to fetch service details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (visible && details && details.id) {
      fetchServiceData();
    }
  }, [visible, details]);

  const confirmDelete = () => {
    deleteService(details.id);
    setVisible(false);
    setUpdatelist(false);
    message.success(`${details.name} has been deleted.`);
  };

  const renderDetails = () => {
    if (!serviceData) {
      return loading ? <p>Loading...</p> : <p>No service details available.</p>;
    }

    const { id, name, description, schedule } = serviceData;
    console.log(serviceData);

    return (
      <div>
        <Descriptions title="Service Details" layout="vertical" bordered>
          <Descriptions.Item label="Service Name" span={2}>
            {name}
          </Descriptions.Item>
          <Descriptions.Item label="Description" span={2}>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </Descriptions.Item>
        </Descriptions>
        <Divider />
        <Button danger style={{ marginRight: "10px" }}>
          <Popconfirm
            title="Are you sure to delete this service?"
            onConfirm={confirmDelete}
            okText="Yes"
            cancelText="No"
          >
            <Link to="#">Delete</Link>
          </Popconfirm>
        </Button>
        <Divider />
        <p className="site-description-item-profile-p">Service Schedules</p>
        <CreateNewSchedule
          service_id={id}
          details={serviceData}
          setUpdatelist={setUpdatelist}
        />
        <ScheduleList id={id} schedule={schedule || []} />
        <Divider />
      </div>
    );
  };

  return (
    <>
      <a onClick={() => setVisible(true)}>View Details</a>
      <Drawer
        width={800}
        placement="right"
        closable={true}
        onClose={handleClose}
        visible={visible}
      >
        {renderDetails()}
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  deleteService,
  getSpecificService,
})(ServiceDetails);
